<template>
  <div class="container success p-3 mb-3">
    <div class="row">
        <div class="col-sm-1 col-12 d-flex justify-content-center align-items-center mb-3">
            <i class="far" :class="icon ? icon : ''"></i>
        </div>
        <div class="col-sm-11 col-12">
            <div class="header mb-3">
                <strong class="pr-1">{{ title }}</strong> <em v-if="estTime" >(Zeitaufwand: ungefähr {{ estTime }})</em>
            </div>

            <div>
                {{ content}}
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Success',
  props: [
    'title',
    'estTime',
    'content',
    'icon',
    'actionText',
    'actionUrl',
    'actionInfo'
  ]

}
</script>
<style scoped>
.success {
  background-color: rgba(0, 152, 35, 0.41);
  border-radius: 5px
}
</style>
